'use strict';

angular.module('atex.art').service('ArtLockingService', ['$rootScope', '$q', 'AuthenticationService', '$http', 'ArtNotificationService', 'ContentService', 'ApplicationConfigurationService',
function($rootScope, $q, AuthenticationService, $http, ArtNotificationService, ContentService, ApplicationConfigurationService) {

  var _appId = "atex.act";
  var self = this;

  var useActivityService = undefined;
  var mockData = {
    'edit': false
  };

  // Class
  function EditInfo(editingUserId, currUserId, timestamp, app) {
    this.edit = !!editingUserId;
    this.lockedBy = editingUserId;
    this.timestamp = timestamp;
    this.app = app;
    this.me = currUserId;
    this.byMe = editingUserId && currUserId && editingUserId === currUserId && app === _appId;
  }

  function _getUserFromServer(id) {
    return getUserInfo(id).then(function (userData) {
      return (typeof userData.firstname !== 'undefined' && typeof userData.lastname !== 'undefined')
          ? [userData.firstname, userData.lastname].join(' ')
          : userData.loginName;
    }, function () {
      return id;
    });
  }

  function getUserInfo(userId) {
    return AuthenticationService.callWithAuthentication(function (currentUser) {
      var deferred = $q.defer();

      var config = {
        "headers": []
      };
      config.headers['X-Auth-Token'] = currentUser.token;

      $http.get('/onecms/principals/users/' + userId, config).then(function (response) {
        var user = response.data;
        user.firstname = user.firstName;
        user.lastname = user.lastName;
        deferred.resolve(user);
      }).then(null, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    });
  }

   // Private
  function _getUserNameById(id) {
    if (!_getUserNameById.cache) {_getUserNameById.cache = {};}
    if (_getUserNameById.cache[id]) {
      return $q.when(_getUserNameById.cache[id]);
    }
    //attempt to get from server
    return _getUserFromServer(id).then(function(username) {
      _getUserNameById.cache[id] = username;
      return username;
    });
  }

//  var _getEditInfo = function(data, currUserID)  {
//    var users = atex.onecms.ObjectUtils.getByPath(data || {}, 'users');
//    for (var key in users) {
//      if (users.hasOwnProperty(key)) {
//        var apps = users[key]['applications'];
//        for (var appKey in apps) {
//          if (apps.hasOwnProperty(appKey)) {
//            var app = apps[appKey];
//            if (app.activity==='edit') {
//              return new EditInfo(key, currUserID, app.timestamp, appKey);
//            }
//          }
//        }
//      }
//    }
//    return new EditInfo();
//  };

  var _getLockInfo = function (data, currUserID) {
    var info;

    var users = atex.onecms.ObjectUtils.getByPath(data || {}, 'users');
    for (var key in users) {
      if (users.hasOwnProperty(key)) {
        var apps = users[key]['applications'];
        for (var appKey in apps) {
          if (apps.hasOwnProperty(appKey)) {
            var app = apps[appKey];
            if (app.activity === 'edit') {
              info = new EditInfo(key, currUserID, app.timestamp, appKey);
            }
          }
        }
      }
    }

    return info;
  };

  var _checkExclusiveLock = function(data, currUserID) {
    var otherLocks = [];
    var myEditInfo;
    var users = atex.onecms.ObjectUtils.getByPath(data || {}, 'users');
    for (var key in users) {
      if (users.hasOwnProperty(key)) {
        var apps = users[key]['applications'];
        for (var appKey in apps) {
          if (apps.hasOwnProperty(appKey)) {
            var app = apps[appKey];
            if (app.activity==='edit') {
              if (currUserID===key && appKey === _appId) {
                myEditInfo = new EditInfo(key, currUserID, app.timestamp, appKey);
              } else {
                otherLocks.push(new EditInfo(key, currUserID, app.timestamp, appKey));
              }
            }
          }
        }
      }
    }
    if (!myEditInfo) {
      throw("Unexpected: the activity should be there!");
    }
    if (otherLocks.length<=0) {
      return myEditInfo;
    }
    // Check if mine is the first lock otherwise return false
    var isFirst = true;
    var otherFound;
    otherLocks.forEach(function(other) {
      if (!otherFound && other.timestamp < myEditInfo.timestamp) {
        otherFound = other;
      }
    });
    if (otherFound) {
      return otherFound;
    }
    return myEditInfo;
  };

//  var _getAllActivities = function(ids) {
//    var getActivitiesPromises = ids.map(function(contentId) {
//      var url = "/onecms/activities/" + contentId;
//      return $http.get(url);
//    });
//    return $q.all(getActivitiesPromises);
//  };

//  var _getLockedIds = function(contentIds, currUserId) {
//    var deferred = $q.defer();
//    _getAllActivities(contentIds).then(function(response) {
//      var lockedEditInfos = [];
//      response.forEach(function(single, idx) {
//        var editInfo = _getEditInfo(single.data, currUserId);
//        if (editInfo.edit && !editInfo.byMe) {
//          editInfo.contentId = contentIds[idx];
//          lockedEditInfos.push(editInfo);
//        }
//      });
//      deferred.resolve(lockedEditInfos);
//    }).then(null, function(error) {
//      deferred.reject(error);
//    });
//    return deferred.promise;
//  };

  var notify = function(type, msg, allEditInfo) {
    function post(username) {
      ArtNotificationService.addNotification(atex.act.Notification({
          type: type,
          message: [msg, username, " in ", allEditInfo.app].join(' ') }),
        true);
    }

    if (allEditInfo.lockedBy !== allEditInfo.me) {
      _getUserNameById(allEditInfo.lockedBy).then( function(username) {
        post(username);
      });
    } else {
      post("you");
    }
  };

  // Public
  self.notifyItemLocked = function(allEditInfo) {
    notify('warning', "Content is being edited by ", allEditInfo);
  };

  self.notifyCollectionItemsLocked = function(lockingUser) {
    notify('warning', "Some content is being edited by ", lockingUser);
  };

//  self.getLockData = function(contentIds)  {
//    if (!useActivityService) {
//      return $q.when(mockData);
//    }
//    return AuthenticationService.callWithAuthentication(function(currentUser) {
//      var deferred = $q.defer();
//      _getAllActivities(contentIds).then(function(response) {
//        var lockData;
//        response.map(function(single) {
//          if (!lockData || !lockData.edit) {
//            lockData = _getEditInfo(single.data, currentUser.principalId);
//          }
//        });
//        deferred.resolve(lockData);
//      }).then(null, function(error) {
//        deferred.reject(error);
//      });
//      return deferred.promise;
//    });
//  };

  var httpConfig = function(currentUser) {
    var config = {'headers' : {}};
    config.headers['X-Auth-Token'] = currentUser.token;
    return config;
  };

  var readConfig = function() {
    if (useActivityService !== undefined) {
      return $q.when();
    }

    useActivityService = false;
    return ApplicationConfigurationService.getConfigurationFor(['locking', 'enabled'], false).then(function(enabled) {
      useActivityService = enabled;
    });
  };

  self.isLocked = function(contentId)  {
    return readConfig().then(function() {
      return _isLocked(contentId);
    });
  };

  self.getUserNameById = function (userId) {
    return _getUserNameById(userId);

  };

  self.lock = function(contentIds, tryLockingCollectionItems)  {
    return readConfig().then(function() {
      return _lock(contentIds, tryLockingCollectionItems);
    });
  };

  var _isLocked = function(contentId)  {
    if (!useActivityService) {
      return $q.when();
    }
    return AuthenticationService.callWithAuthentication(function(currentUser) {
      var deferred = $q.defer();

      var url = "/onecms/activities/" + contentId;
        $http.get(url, httpConfig(currentUser)).then(function(lockStatus) {
        var locked = _getLockInfo(lockStatus.data,currentUser.principalId);
        deferred.resolve(locked);
      }).then(null, function(error){
        notify('error', atex.onecms.ObjectUtils.getByPath(error || {}, 'data/message'));
        error.notified = true;
        deferred.reject(error);
      });

      return deferred.promise;
    });
  };

  var _lock = function(contentIds, tryLockingCollectionItems)  {
    if (!useActivityService) {
      return $q.when();
    }
    return AuthenticationService.callWithAuthentication(function(currentUser) {
      var deferred = $q.defer();
      var lockPromises = contentIds.map(function(contentId) {
        var url = "/onecms/activities/" + contentId + "/" + currentUser.principalId + "/" + _appId;
        return $http.put(url, {'activity' : 'edit'}, httpConfig(currentUser));
      });
      $q.all(lockPromises).then(function(responses){
        var allEditInfo;
        responses.forEach(function(response){
          if (!allEditInfo || allEditInfo.byMe) {
            allEditInfo = _checkExclusiveLock(response.data, currentUser.principalId);
          }
        });
        if (allEditInfo.byMe) {
          deferred.resolve(responses);
        } else {
          // There is some object that was previously locked by someone else, we have to revert all the lock activities!
          var deletePromises = responses.map(function(response) {
            return $http.delete(response.config.url, httpConfig(currentUser));
          });
          $q.all(deletePromises).then(function(responses){
            if (tryLockingCollectionItems) {
              self.notifyCollectionItemsLocked(allEditInfo);
              deferred.reject({childsLocked: true, notified: true});
            } else {
              self.notifyItemLocked(allEditInfo);
              deferred.reject({objectLocked: true, notified: true});
            }
          }).then(null, function(error){
            deferred.reject(error);
          });
        }
      }).then(null, function(error){
        notify('error', atex.onecms.ObjectUtils.getByPath(error || {}, 'data/message'));
        error.notified = true;
        deferred.reject(error);
      });
      return deferred.promise;
    });
  };

  // remove current user activity
  self.unlock = function(contentIds)  {
    return readConfig().then(function() {
      return _unlock(contentIds);
    });
  };

  function isArrayOfContentId(object, path) {
    if (path.indexOf('_type') !== -1) {
      return false;
    }
    var element_types = atex.onecms.ObjectUtils.getByPath(object, path + '_element_types') || null;
    if (element_types !== null) {
      var type = atex.onecms.ObjectUtils.getByPath(object, path + '_type');
      return type.indexOf('com.atex.onecms.content.ContentId') !== -1;
    }
    return false;
  }

  function _unlockResources(contents) {
    if (contents && contents.length > 0) {
      var cleanContents = [];
      contents.forEach(function (content) {
        if (content.startsWith('contentid/')) {
          content = content.replace('contentid/', '');
        }
        cleanContents.push(content);
      });
      return self.unlock(cleanContents);
    } else {
      return $q.when();
    }
  }

  var unlockResources = function (article) {
    var dataPath = 'data/aspects/contentData/data';
    var data = atex.onecms.ObjectUtils.getByPath(article, dataPath) || [];
    var promises = Object.keys(data).filter(function (key) {
      return isArrayOfContentId(article, dataPath + '/' + key);
    }).map(function (key) {
      var objectArray = atex.onecms.ObjectUtils.getByPath(article, dataPath + '/' + key);
      return _unlockResources(objectArray);
    });
    return $q.all(promises);
  };

  var _unlockAll = function (article) {
    if (article) {
      return unlockResources(article).then(function () {
        return self.unlock([article.meta.id]);
      });
    } else {
      return $q.when();
    }
  };

  self.unlockAll = function(article) {
    return _unlockAll(article);
  };

  var _unlock = function(contentIds)  {
    if (!useActivityService) {
      return $q.when();
    }
    return AuthenticationService.callWithAuthentication(function(currentUser) {
      var deferred = $q.defer();
      var unlockPromises = contentIds.map(function(contentId) {
        var url = "/onecms/activities/" + contentId + "/" + currentUser.principalId + "/" + _appId;
        return $http.delete(url, httpConfig(currentUser));
      });
      $q.all(unlockPromises).then(function(responses) {
        deferred.resolve(responses);
      }).then (null, function(error) {
        notify('error', atex.onecms.ObjectUtils.getByPath(error || {}, 'data/message'));
        error.notified = true;
        deferred.reject(error);
      });
      return deferred.promise;
    });
  };

  // remove other user activity
  self.removeActivity = function(contentId, principalId, appId)  {
    if (!useActivityService) {
      return $q.when();
    }
    return AuthenticationService.callWithAuthentication(function(currentUser) {
      var deferred = $q.defer();
      var url = "/onecms/activities/" + contentId + "/" + principalId + "/" + appId;
      $http.delete(url, httpConfig(currentUser)).then(function(response) {
        deferred.resolve(response);
      }).then (null, function(error) {
        notify('error', atex.onecms.ObjectUtils.getByPath(error || {}, 'data/message'));
        error.notified = true;
        deferred.reject(error);
      });
      return deferred.promise;
    });
  };

  // returns an array of locked items with EditInfo
//  self.getLockedItems = function(contentIds)  {
//    if (!useActivityService) {
//      return $q.when();
//    }
//    return AuthenticationService.callWithAuthentication(function(currentUser) {
//      var deferred = $q.defer();
//      _getLockedIds(contentIds, currentUser.principalId).then(function(lockedEditInfos) {
//        var lockedItems = [];
//        var getPromises = lockedEditInfos.map(function(editInfo) {
//          var def = $q.defer();
//          ContentService.getContent({ id: editInfo.contentId}).then(function(response){
//            response.data.lockData = editInfo;
//            def.resolve(response);
//          }).then (null, function(error) {
//            def.reject(error);
//          });
//          return def.promise;
//        });
//        $q.all(getPromises).then(function(responses) {
//          deferred.resolve(responses);
//        });
//      }).then (null, function(error) {
//        deferred.reject(error);
//      });
//      return deferred.promise;
//    });
//  };


  self.lockCollection = function(collectionId) {
    if (!useActivityService) {
      return $q.when();
    }
    return AuthenticationService.callWithAuthentication(function(currentUser) {
      var deferred = $q.defer();
      var allChildsIDs = [];
      var collectionLocked = false;
      self.lock([collectionId]).then(function(lockData) {
        collectionLocked = true;
        /* jshint -W117 */
        // [TODO] CollectionService does not seems to exists.
        return CollectionService.getCollectionChildsIDs(collectionId);
        /* jshint +W117 */
      }).then(function(contentIds){
        allChildsIDs = contentIds;
        return self.lock(contentIds, true);
      }).then(function(lockData){
        deferred.resolve(lockData);
      }).then(null, function(error) {
        if (collectionLocked) {
          self.unlock([collectionId]);
        }
        if (error.childsLocked) {
          error.allChildsIDs = allChildsIDs;
        }
        deferred.reject(error);
      });
      return deferred.promise;
    });
  };

  self.useActivityService = function() {
    return useActivityService;
  };

}]);
